class SunRotation {
  constructor() {
    this.sun = document.querySelector('img[src*="sun-icon.svg"]');
    this.rotation = 0;
    this.targetRotation = 0;
    this.easing = 0.75; // Inertia factor (lower = more inertia)
    this.scrollFactor = 0.25; // How much scroll affects rotation
    
    if (this.sun) {
      this.init();
    }
  }

  init() {
    // Add transition for smooth rotation
    this.sun.style.transition = 'transform 0.1s ease-out';
    
    // Listen for scroll events
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // Start animation loop
    requestAnimationFrame(this.animate.bind(this));
  }

  handleScroll() {
    // Calculate target rotation based on scroll position
    this.targetRotation = window.scrollY * this.scrollFactor;
  }

  animate() {
    // Apply easing to rotation
    this.rotation += (this.targetRotation - this.rotation) * this.easing;
    
    // Apply rotation to sun
    this.sun.style.transform = `rotate(${this.rotation}deg)`;
    
    // Continue animation loop
    requestAnimationFrame(this.animate.bind(this));
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new SunRotation();
}); 